<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 text-gray-900 relative overflow-hidden">
    <div class="absolute inset-0 opacity-5">
      <div class="absolute inset-0" style="background-image: radial-gradient(#94a3b8 1px, transparent 1px); background-size: 30px 30px;"></div>
    </div>

    <div class="relative z-10 p-4 sm:p-6 lg:p-8 mt-5">
      <div class="max-w-3xl mx-auto mb-6 text-center">
        <div class="inline-flex items-center gap-3 mb-2">
          <h1 class="text-3xl md:text-4xl font-bold text-gray-900">
            {{ $t('reportType.title') }} <span class="text-blue-600">{{ $t('reportType.titleHighlight') }}</span>
          </h1>
        </div>
        <p class="text-gray-600 text-lg">{{ $t('reportType.subtitle') }}</p>
      </div>

      <div class="max-w-4xl mx-auto">
        <div class="bg-white/80 backdrop-blur-xl rounded-2xl p-6 sm:p-8 shadow-2xl border border-gray-200/50">
          <h2 class="text-xl sm:text-2xl font-bold text-center mb-2 text-gray-900">{{ $t('reportType.chooseType') }}</h2>
          <p class="text-gray-500 text-center mb-8 text-sm">{{ $t('reportType.chooseTypeDesc') }}</p>

          <div class="flex justify-center">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl">
              <!-- Cyber Incident Card -->
              <button 
                @click="selectType('cyber')" 
                class="report-type-card group" 
                :class="{ active: selected === 'cyber' }"
              >
                <div class="flex flex-col items-center justify-center p-4">
                  <div class="w-16 h-16 bg-gradient-to-br from-red-500 to-orange-600 rounded-full flex items-center justify-center mb-2 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <h3 class="text-lg font-bold mb-1 text-gray-900">{{ $t('reportType.cyberTitle') }}</h3>
                  <p class="text-gray-600 text-center text-xs">{{ $t('reportType.cyberDesc') }}</p>
                </div>
              </button>

              <!-- Complaint Card -->
              <button 
                @click="selectType('complaint')" 
                class="report-type-card group" 
                :class="{ active: selected === 'complaint' }"
              >
                <div class="flex flex-col items-center justify-center p-4">
                  <div class="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mb-2 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h3 class="text-lg font-bold mb-1 text-gray-900">{{ $t('reportType.complaintTitle') }}</h3>
                  <p class="text-gray-600 text-center text-xs">{{ $t('reportType.complaintDesc') }}</p>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="border-t border-gray-200 bg-white w-full mt-12">
      <div class="container mx-auto px-4 py-4">
        <div class="flex flex-col md:flex-row justify-between items-center gap-3">
          <p class="text-xs text-gray-600">&copy; 2024 ANTIC CIRT</p>
          <div class="flex items-center gap-4 text-xs text-gray-500">
            <a href="#" class="hover:text-gray-900 transition-colors">{{ $t('reportType.privacy') }}</a>
            <a href="#" class="hover:text-gray-900 transition-colors">{{ $t('reportType.terms') }}</a>
            <a href="#" class="hover:text-gray-900 transition-colors">{{ $t('reportType.help') }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportTypeSelection',
  data() {
    return { selected: null };
  },
  computed: {
    currentLang() {
      return this.$route.params.lang || this.$i18n.locale || 'en';
    }
  },
  methods: {
    selectType(type) {
      this.selected = type;
      this.$nextTick(() => {
        setTimeout(() => {
          const lang = this.currentLang;
          this.$router.push({ name: 'recaptcha-gate', params: { lang, type } });
        }, 300);
      });
    }
  }
};
</script>

<style scoped>
.report-type-card {
  @apply bg-white border-2 border-gray-200 rounded-xl cursor-pointer
         transition-all duration-300 hover:border-blue-500 hover:shadow-lg
         relative overflow-hidden hover:scale-[1.02];
}

.report-type-card.active {
  @apply border-blue-500 bg-blue-50/50 shadow-lg shadow-blue-500/20;
}
</style>